import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { IconIrisScannerProps } from './IconIrisScanner.types'
import * as Styled from './styles/IconIrisScanner.style'

import { nonThemeableRules } from '../../ruleSet'

const IconIrisScanner: FC<IconIrisScannerProps> = ({
  size = nonThemeableRules.defaultSize as number as IconIrisScannerProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: IconIrisScannerProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
        <g fill='none'>
          <path
            d='M11.95 17.875c-5.759 0-8.364-5.367-8.462-5.617a.628.628 0 0 1 .043-.535c.375-.735 3-5.48 8.418-5.48 5.758 0 8.364 5.374 8.465 5.616.031.094.043.2.031.297a.654.654 0 0 1-.078.242c-.383.743-3.008 5.477-8.418 5.477Zm0 0'
            vectorEffect='non-scaling-stroke'
          />
          <path
            d='M11.95 15.5a3.483 3.483 0 0 1-3.47-3.492 3.483 3.483 0 0 1 3.485-3.477 3.483 3.483 0 0 1 3.484 3.477A3.483 3.483 0 0 1 11.98 15.5ZM6.5 3.5h-3v3m0 11v3h3m11 0h3v-3m0-11v-3h-3'
            vectorEffect='non-scaling-stroke'
          />
        </g>
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default IconIrisScanner
